import { connect } from "vuex-connect";
import { ComicSize } from "../../../components";

export default connect({
  stateToProps: {
    pageProgressionDirection: state =>
      state.uploadContents.pageProgressionDirection,
    images: state => state.uploadContents.images,
    isUploadIceContents: state => state.uploadContents.isUploadIceContents,
    iceContentsPageCount: state => state.uploadContents.iceContentsPageCount,
    defaultThumbnailOriginalImageUrl: state =>
      state.uploadContents.defaultThumbnailOriginalImageUrl,
    frontCoverType: state => state.uploadContents.frontCoverType,
    isSetSpine: state => state.uploadContents.isSetSpine,
    sizeSelect: state => state.uploadContents.sizeSelect,
    orientation: state => state.uploadContents.orientation,
    userFrontCoverImageUrl: state => state.uploadContents.userFrontCoverImageUrl
  },
  mutationsToProps: {
    updateIsSetSpine: (commit, value) =>
      commit("uploadContents/updateIsSetSpine", value),
    updateSizeSelect: (commit, value) =>
      commit("uploadContents/updateSizeSelect", value)
  }
})(ComicSize.name, ComicSize);
